// extracted by mini-css-extract-plugin
export var compactFilters = "_cx-4";
export var detailImage = "_cx-1";
export var dropdownContainer = "_cx-2";
export var imageContainer = "_cx-0";
export var selectedCard = "_cx-3";